module.exports = __webpack_public_path__ + "static/media/Basic Electrical.b2563652.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EEE/Basic Electrical.pdf
// module id = 124
// module chunks = 0